export default __webpack_public_path__ + "static/media/CityscapeLogoColor.d2609262.png";